import type { ILoadTaskOptions } from 'task-loader';
import { AbstractLoadTask } from 'task-loader';

export default class LoadProgressMethodTask extends AbstractLoadTask<unknown> {
  declare protected options: LoadProgressMethodTaskOptions;
  private onProgressUpdateCallback!: ((progress: number) => void) | null;
  private loadComplete: boolean = false;

  public constructor(options: LoadProgressMethodTaskOptions = { assets: [] }) {
    super(Object.assign(options, { batchSize: 1, cached: false }));
  }

  public loadAsset(): Promise<void> {
    return Promise.resolve();
  }

  public setProgress(progress: number): void {
    if (progress >= 100) {
      this.loadComplete = true;
    }

    if (this.onProgressUpdateCallback) this.onProgressUpdateCallback(progress);
  }

  public onProgressUpdate(callback: (progress: number) => void): void {
    this.onProgressUpdateCallback = callback;
  }

  public load(update: (progress: number) => void): Promise<void> {
    return new Promise((resolve) => {
      if (!this.loadComplete) {
        this.onProgressUpdate((value) => {
          update(value / 100);

          if (this.loadComplete) {
            resolve();
          }
        });
      } else {
        update(1);
        resolve();
      }
    });
  }

  public dispose(): void {
    if (this.onProgressUpdateCallback) {
      this.onProgressUpdateCallback = null;
    }
    super.dispose();
  }
}

export interface LoadProgressMethodTaskOptions extends ILoadTaskOptions<unknown> {
  params?: { [key: string]: unknown };
  name?: string;
}
